import React from "react";
import TimelineItem, {
	TimelineItemProps,
} from "common/TimelineItem/TimelineItem";

interface TimelineProps {
	historyData: any[];
}

const Timeline: React.FC<TimelineProps> = ({ historyData }) => {
	const mapStatusToFrontend = (
		backendStatus: string
	): "accepted" | "confirmed" | "haveTo" | "rejected" | "archieve" => {
		switch (backendStatus) {
			case "Täze kabul edildi":
				return "accepted";
			case "Tassyklandy":
				return "confirmed";
			case "Ýerine ýetirmeli":
				return "haveTo";
			case "Ýerine ýetirmedi":
				return "rejected";
			case "Arhiwda":
				return "archieve";
			default:
				return "accepted"; // Ensure this is handled in your TimelineItem component
		}
	};

	const timelineData = historyData.map((item) => ({
		date: new Date(item.createdAt).toLocaleDateString("en-GB", {
			day: "2-digit",
			month: "2-digit",
			year: "numeric",
		}),
		person: item.sentTo || item.fromWho,
		positionName:
			item.sentUser?.userTypeId.positionName ||
			item.fromUser?.userTypeId.positionName,
		action: item.status,
		status: mapStatusToFrontend(item.status),
		documents: item.files,
		note: item.note,
		checked: item.checked,
		expired: item.expired,
	}));

	return (
		<div className="w-full">
			<div className="grid grid-flow-row grid-cols-1 gap-3 auto-rows-max">
				{timelineData.map((item, index) => (
					<TimelineItem key={index} item={item} />
				))}
			</div>
		</div>
	);
};

export default Timeline;
